import React, { useEffect, useState } from 'react';
import NxtbnModal from '../../Modal';
import { NXForm, InputField } from '../../common';
import { use } from 'echarts';
import SelectStyled from '../../Select';
import countryList from 'react-select-country-list';

interface AddressFormProps {
  isOpen: boolean;
  onClose: () => void;
  isShipping: boolean;
  onSubmit: (data: any, isShipping: boolean) => void;
  defaultData: any;
}

const AddressForm: React.FC<AddressFormProps> = ({ defaultData, isOpen, onClose, onSubmit, isShipping }) => {
    const [formData, setFormData] = useState<any>({});
    const country = countryList().getData()
    const [errorData, setErrorData] = useState<any>()

    const HandlehandleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onClose();
        onSubmit(formData, isShipping);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData((prev:any) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const onSelectHandler = (e:any) => {
      setFormData((prev:any)=> ({...prev, country: e.value}))
    }

    useEffect(() => {
        setFormData(defaultData);
    }, [defaultData]);

  return (
    <NxtbnModal isOpen={isOpen} onClose={onClose}>
      <NXForm className="p-6 space-y-4" onSubmit={HandlehandleSubmit} title={isShipping ? 'Shipping Address' : 'Billing Address'}>
        <div className="grid grid-cols-1 gap-y-4 sm:grid-cols-2 sm:gap-x-6">
          <div>
            <label htmlFor="firstName" className="block text-sm font-medium text-gray-700">
              First Name
            </label>
            <InputField
              type="text"
              id="firstName"
              name="first_name"
              value={formData?.first_name || ''}
              onChange={handleChange}
              required
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>
          <div>
            <label htmlFor="lastName" className="block text-sm font-medium text-gray-700">
              Last Name
            </label>
            <InputField
              type="text"
              id="lastName"
              name="last_name"
              value={formData?.last_name || ''}
              onChange={handleChange}
              required
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>
          <div>
            <label htmlFor="streetAddress" className="block text-sm font-medium text-gray-700">
              Street Address
            </label>
            <InputField
              type="text"
              id="streetAddress"
              name="street_address"
              value={formData?.street_address || ''}
              onChange={handleChange}
              required
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>
          <div>
            <label htmlFor="city" className="block text-sm font-medium text-gray-700">
              City
            </label>
            <InputField
              type="text"
              id="city"
              name="city"
              value={formData?.city || ''}
              onChange={handleChange}
              required
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>
          <div>
            <label htmlFor="region" className="block text-sm font-medium text-gray-700">
              Region/State
            </label>
            <InputField
              type="text"
              id="region"
              value={formData?.state || ''}
              onChange={handleChange}
              name="state"
              required
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>
          <div>
            <label htmlFor="country" className="block text-sm font-medium text-gray-700">
              Country
            </label>
            <SelectStyled
                name="country"
                options={country}
                defaultValue={country.find((item) => item.value === formData?.country)}
                onChange={onSelectHandler}
                errorData={errorData}
              />
          </div>
          <div>
            <label htmlFor="postalCode" className="block text-sm font-medium text-gray-700">
              Postal Code
            </label>
            <InputField
              type="text"
              id="postalCode"
              onChange={handleChange}
              name="postal_code"
              value={formData?.postal_code || ''}
              required
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>
          <div>
            <label htmlFor="phoneNumber" className="block text-sm font-medium text-gray-700">
              Phone Number (Optional)
            </label>
            <InputField
              type="text"
              id="phoneNumber"
              onChange={handleChange}
              value={formData?.phone_number || ''}
              name="phone_number"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
              Email (Optional)
            </label>
            <InputField
              type="email"
              id="email"
              onChange={handleChange}
              value={formData?.email || ''}
              name="email"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>
        </div>
        <div className="mt-6 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="mr-3 inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-gray-600 text-base font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-primary-600 text-base font-medium text-white shadow-sm hover:bg-primary-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
          >
            Submit
          </button>
        </div>
      </NXForm>
    </NxtbnModal>
  );
};

export default AddressForm;
